import axios from "../helper/axios";
import { apiUrl } from "../config/config";
export async function getReferralHistory(postData) {
  try {
    let res = await axios.Get({
      url: `${apiUrl}/rpc/cashout/options`,
      data: postData
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.message };
      } else {
        return { error: e.message };
      }
    } else {
      return { error: e.message };
    }
  }
}